import React from 'react'
import { ReactSelect } from '@softura/customcomponent'
import './index.scss'

interface IProps {
  className?: string,
  options?:any,
  isMulti?:any
}

const MultiselectContainer = ({className, isMulti, options}:IProps) => {
  return (
    <ReactSelect
      className = {`multiselect-input ${className}`}
      isMulti = {isMulti}
      options = {options}
    >
    </ReactSelect>
  )
}

export default MultiselectContainer
